import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public submitted: boolean = false;
  public loading: boolean = false;
  public passwordForm:any
  constructor( public toaster: ToastrService,
    public router: Router,
    private formBuilder: FormBuilder,) {
     }

  ngOnInit() {
    this.passwordForm = this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
      ])]
    });
  }

  get f() { return this.passwordForm.controls; }
  resetPassword() {
   
    var self = this;
    this.submitted = true ;
    if(this.passwordForm.valid) {
      this.loading = true;
      this.submitted = false ;
      firebase.auth().sendPasswordResetEmail(self.passwordForm.get("email").value)
      .then(() => {
        self.toaster.success('Password reset link sent to your email. Please check your email shortly. ','', {timeOut:15000});
        this.loading = false;
        self.router.navigate(['/login']);

      })
      .catch((e) => {
        this.loading = false;
        self.toaster.error(e,'', {timeOut:4000});
      })
    }
    
    }
}
